import type {
  schemaType,
  paramsType,
  returnType,
} from '~~/shared/api/rurality/v3/cottages/conditions/schema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/cottages/conditions'

export const serverFetch = (params: paramsType): Promise<returnType> =>
  serverFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  browserFetchWrapper<paramsType, schemaType>(endpoint, params)
